export enum CReqExecutionResultEnum {
    Ok = "Ok",
    /// <summary>
    /// Richiesta non valida
    /// </summary>
    InvalidRequest = "InvalidRequest",

    /// <summary>
    /// Errore del server
    /// </summary>
    ServerError = "ServerError",

    /// <summary>
    /// Richiesta autenticazione
    /// Viene restituito si tenta un comando senza autenticazione o se la sessione è scaduta
    /// </summary>
    AuthenticationRequired = "AuthenticationRequired",

    /// <summary>
    /// L'utente loggato non ha i diritti per richiedere l'esecuzione del comando inviato
    /// </summary>
    PermissionDenied = "PermissionDenied",

    /// <summary>
    /// L'identificativo del server non è valido
    /// </summary>
    SIDNotValid = "SIDNotValid",

    /// <summary>
    /// La licenza del client è scaduta
    /// </summary>
    LicenseExpired = "LicenseExpired",

    /// <summary>
    /// Il client è già presente in sessione
    /// </summary>
    ClientAlreadyPresent = "ClientAlreadyPresent",

    /// <summary>
    /// Il server sta elaborando la richiesta
    /// Mod 1337779
    /// </summary>
    ServerBusy = "ServerBusy",

    /// <summary>
    /// Numero massimo di connessioni raggiunto
    /// Mod 1344793
    /// </summary>
    ConnectionLimitReached = "ConnectionLimitReached",

    /// <summary>
    /// Server di licenza non raggiungibile
    /// Mod 1344793
    /// </summary>
    LicenseServerOffline = "LicenseServerOffline",

    /// <summary>
    /// Mod 1416842
    /// file da trasferire non trovato
    /// </summary>
    FileNotFound = "FileNotFound",

    /// <summary>
    /// Mod 1437887
    /// </summary>
    AgentOffline = "AgentOffline",

    /// <summary>
    /// Device lockato da altre operazioni
    /// </summary>
    DeviceLocked = "DeviceLocked",

    /// <summary>
    /// Firma del file non valida
    /// </summary>
    SignatureNotValid = "SignatureNotValid",

    /// <summary>
    /// Agente non installato
    /// </summary>
    AgentNotInstalled = "AgentNotInstalled",

    /// <summary>
    /// Operazione non disponibile
    /// </summary>
    OperationNotAvailable = "OperationNotAvailable",
}

export function CReqExecutionResultEnumToI18n(val: number): string {
    let enumToString = [
        "Ok",
        "InvalidRequest",
        "ServerError",
        "AuthenticationRequired",
        "PermissionDenied",
        "SIDNotValid",
        "LicenseExpired",
        "ClientAlreadyPresent",
        "ServerBusy",
        "ConnectionLimitReached",
        "LicenseServerOffline",
        "FileNotFound",
        "AgentOffline",
        "DeviceLocked",
        "SignatureNotValid",
        "AgentNotInstalled",
        "OperationNotAvailable",
    ];
    return `enum.cReqExecutionResultEnum.${enumToString[val]}`;
}

export function CReqExecutionResultEnumToString(val: CReqExecutionResultEnum): string {
    return `enum.cReqExecutionResultEnum.${CReqExecutionResultEnum[val]}`;
}
